export default function useElevio() {
  return (window as any)._elev || {};
}
